export const SENTRY_IGNORE_ERRORS: Array<string | RegExp> = [
  'Non-Error exception captured',
  'Non-Error promise rejection captured',
  'Failed to export with XHR (status: 0)',

  /Minified\s+React\s+error\s+#(418|421|423|425)/gi,
  /is not a function.*__iabjs|UserMessageHandlersNamespace/gi,
  /SyntaxError.*Unexpected token\s+['"]?\./i,
  /Invariant:\s+attempted\s+to\s+hard\s+navigate\s+to\s+the\s+same\s+URL/i, // https://sentry.io/answers/handle-hard-navigation-errors-in-nextjs/
  /Network Error/i,

  // Domain-related errors (could be different property names)
  /Cannot read properties of undefined \(reading 'Domain(Data)?'\)/i,
  /undefined is not an object \(evaluating '[^']*\.Domain(Data)?'\)/i,

  // Generic browser/extension errors
  /null is not an object \(evaluating 'this\.selector\.appendChild'\)/i,
  /Error invoking \*: Java object is gone/i,
  /Maximum call stack size exceeded/i,
  /Invalid call to runtime\.sendMessage\(\)\. Tab not found/i,
  /Cannot read properties of undefined \(reading 'domInteractive'\)/i,
  /undefined is not an object \(evaluating 'window\.webkit\.[^']+'\)/i,

  // OneTrust cookie consent errors
  /undefined is not an object \(evaluating '[^']*\.bannerGroup\.html'\)/i,
];
